setTimeout(()=>{
    let popUpModals = document.querySelectorAll(".pop-up__modal-trigger");
    let popUpContent = document.querySelector("#popup");
    let closeBtnOrig = document.querySelector(".popup--close-btn");
    popUpModals.forEach(popUpTrigger => {
        popUpTrigger.addEventListener("click", ()=> {

            let popUp = document.createElement('div');
            popUp.className = 'pop-up__modal-content';
            popUp.innerHTML = popUpContent.innerHTML;


            let popUpCloseBtn = document.createElement('div');
            popUpCloseBtn.className = 'pop-up__modal-close popup--close-btn';
            popUpCloseBtn.innerHTML = closeBtnOrig.innerHTML;
            popUp.querySelector("#fullscreen .popup_image").append(popUpCloseBtn);

            let popUpCloseWrap = document.createElement('div');
            popUpCloseWrap.className = 'pop-up__modal-close-wrap';
            popUp.append(popUpCloseWrap);


            document.body.append(popUp);
            document.body.style.overflow = "hidden";
            popUp.classList.add("open");

            setTimeout(() => {
                popUpCloseBtn.addEventListener( 'click', (e) => {
                    popUp.classList.remove("open");
                    document.body.style.overflow = "visible";
                })
                popUpCloseWrap.addEventListener( 'click', (e) => {
                    popUp.classList.remove("open");
                    document.body.style.overflow = "visible";
                })
            }, 0);
        })
    });
}, 1500);